import { Route } from '@angular/router';
import { RootGuard } from '@ec/authentication';

export const appRoutes: Route[] = [
  {
    path: '',
    loadComponent: () => import('./app.component').then(x => x.AppComponent),
    pathMatch: 'full',
    canActivate: [RootGuard]
  },
  {
    path: 'auth',
    loadChildren: () => import('./modules/auth/auth.routes').then(o => o.authRoutes)
  },
  {
    path: 'public',
    loadChildren: () => import('./modules/public/public.routes').then(m => m.publicRoutes)
  },
  {
    path: 'risk-profile',
    loadChildren: () => import('./modules/risk-profile/risk-profile.routes').then(m => m.riskProfileRoutes)
  },
  {
    path: 'customer',
    loadChildren: () => import('./modules/customer/customer.routes').then(m => m.customerRoutes)
  }
];
